import React, { useContext, useEffect } from "react";
import AddNewProduct from "./components/AddNewProduct/AddNewProduct";
import Products from "./components/Products/Products";
import { AppContext } from "../../store/AppContext";

const ProductsTab = () => {
  const { productsTabInfo, selectedTab, setProductsTabInfo } =
    useContext(AppContext);

  useEffect(() => {
    // Only clear the form overlay on mount — do not wipe page / filters
    // or pagination is lost when remounting after viewing a product.
    setProductsTabInfo((prev) => ({
      ...prev,
      addProduct: false,
      selectedProduct: null,
    }));
  }, []);

  return (
    <>
      {selectedTab?.subCategory?.index === 0 &&
        (productsTabInfo?.addProduct || productsTabInfo?.selectedProduct ? (
          <AddNewProduct />
        ) : (
          <Products />
        ))}
    </>
  );
};

export default ProductsTab;
